const Error = () =>
(
    <div>500 API Server Error</div>
);

export default Error;